import { Alert, ListGroupItem } from "react-bootstrap";

/** The place of an insight whose read failed (APP-2129, R25). */
const InsightFailed = () => (
  <ListGroupItem>
    <Alert variant="danger" className="mb-0">
      Failed to load insight
    </Alert>
  </ListGroupItem>
);

export default InsightFailed;
